import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  inputStyles,
} from "../../../constants/Styles";

export const DateInputContainer = styled.div`
  ${inputStyles};
  justify-content: space-between;
  align-items: center;
  min-width: 12rem;
  gap: 0.5rem;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${FONT_SIZE.size18};
  font-family: ${FONTS.spaceGrotesk};
`;

export const DateHeader = styled.div`
  font-weight: ${FONT_WEIGHT.weight700};
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.secondaryLight};
`;

function getBackgroundColor(backgroundColor?: string) {
  if (backgroundColor !== undefined) {
    return backgroundColor;
  }
  return "inherit";
}

const getBorder = (selected?: boolean, leadTimeStartDate?: boolean) => {
  if (leadTimeStartDate) {
    return `2px ${COLORS.secondary} dotted`;
  }
  if (selected) {
    return `2px ${COLORS.secondary} solid`;
  }
  return "none";
};

const getTextDecoration = (inThePast?: boolean, today?: boolean) => {
  if (inThePast) {
    return "line-through";
  }
  if (today) {
    return "underline";
  }
  return "inherit";
};

export const DateCell = styled.div<{
  today?: boolean;
  inThePast?: boolean;
  isWeekend?: boolean;
  leadTimeStartDate?: boolean;
  selected?: boolean;
  backgroundColor?: string;
}>`
  width: 2rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 0.25rem;
  text-decoration: ${({ inThePast, today }) =>
    getTextDecoration(inThePast, today)};
  border: ${({ selected, leadTimeStartDate }) =>
    getBorder(selected, leadTimeStartDate)};
  color: ${({ inThePast, isWeekend }) =>
    inThePast || isWeekend ? COLORS.secondaryLight : COLORS.secondary};
  background-color: ${({ backgroundColor }) =>
    getBackgroundColor(backgroundColor)};
`;

export const LegendTitle = styled.div`
  text-align: center;
  font-size: ${FONT_SIZE.size18};
  font-family: ${FONTS.spaceGrotesk};
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const LegendRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FlashPCBCalendarContainer = styled.div`
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
